import type { Work } from "@/mocks/manhwaData";

interface WorkCardProps {
  work: Work;
  showRank?: number;
}

export default function WorkCard({ work, showRank }: WorkCardProps) {
  return (
    <article className="group relative overflow-hidden rounded-2xl bg-background-100 border border-background-200/70 transition-transform duration-300 hover:-translate-y-1">
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={work.cover}
          alt={`${work.title}韩漫封面`}
          title={`${work.title} · ${work.categoryName} · 正版韩漫`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-2.5 top-2.5 rounded-full px-2.5 py-1 text-xs font-medium text-background-50 ${
            work.status === "连载中" ? "bg-accent-500" : "bg-secondary-500"
          }`}
        >
          {work.status}
        </span>
        {showRank && (
          <span className="absolute right-2.5 top-2.5 flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 font-heading text-sm text-background-50">
            {showRank}
          </span>
        )}
      </div>
      <div className="p-3.5">
        <h3 className="truncate text-sm font-semibold text-foreground-950 md:text-base">
          {work.title}
        </h3>
        <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
          <span>{work.categoryName}</span>
          <span className="h-3 w-px bg-background-300"></span>
          <span className="flex items-center gap-0.5 text-secondary-600">
            <i className="ri-star-fill text-xs"></i>
            {work.rating.toFixed(1)}
          </span>
        </p>
        <div className="mt-2.5 flex flex-wrap gap-1.5">
          {work.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}